import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=3f396602"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f396602')) {
      api.createRecord('3f396602', component.options)
    } else {
      api.reload('3f396602', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=3f396602", function () {
      api.rerender('3f396602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/Create.vue"
export default component.exports